<div>
    <app-label-list
        [labels]="labels"
        [orderId]="entityId"
        [type]="labelType"
        (labelsSelected)="labelsSelected($event)"></app-label-list>
</div>
